const askquestion = {
    // Header Section
    "discover_your": "ನಿಮ್ಮ",
    "ask_question": "ಪ್ರಶ್ನೆ ಕೇಳಿ",
    "personalized_answers": "ವೈಯಕ್ತಿಕ ಜ್ಯೋತಿಷ್ಯ ಉತ್ತರಗಳು",
    "ask_question_description": "ನಿಮ್ಮ ಜೀವನದ ಬಗ್ಗೆ ಯಾವುದೇ ನಿರ್ದಿಷ್ಟ ಪ್ರಶ್ನೆಯನ್ನು ಕೇಳಿ ಮತ್ತು ವಿಸ್ತೃತ ಜ್ಯೋತಿಷ್ಯ ಉತ್ತರಗಳನ್ನು ಪಡೆಯಿರಿ. ನಮ್ಮ ತಜ್ಞ ಜ್ಯೋತಿಷಿಗಳು ಪ್ರಾಯೋಗಿಕ ಮಾರ್ಗದರ್ಶನ ಮತ್ತು ಪರಿಹಾರ ಪರಿಹಾರಗಳೊಂದಿಗೆ ನಿಮ್ಮ ಜನ್ಮ ಚಾರ್ಟ್‌ನ ಆಧಾರದ ಮೇಲೆ ವೈಯಕ್ತಿಕ ಒಳನೋಟಗಳನ್ನು ಒದಗಿಸುತ್ತಾರೆ.",

    // Service Information
    "enter_details_for_question": "ನಿಮ್ಮ ವಿವರಗಳು ಮತ್ತು ಪ್ರಶ್ನೆಯನ್ನು ನಮೂದಿಸಿ",
    "personalized_question_answer": "ವೈಯಕ್ತಿಕ ಪ್ರಶ್ನೆ ಉತ್ತರ",
    "service_price": "ಸೇವೆಯ ಬೆಲೆ",
    "personalized_question_answer_note": "ಮಾರ್ಗದರ್ಶನದೊಂದಿಗೆ ನಿಮ್ಮ ನಿರ್ದಿಷ್ಟ ಪ್ರಶ್ನೆಗೆ ತಜ್ಞ ಜ್ಯೋತಿಷ್ಯ ಉತ್ತರ",

    // Form Fields
    "full_name": "ಪೂರ್ಣ ಹೆಸರು",
    "enter_full_name": "ನಿಮ್ಮ ಪೂರ್ಣ ಹೆಸರನ್ನು ನಮೂದಿಸಿ",
    "name_question_context": "ನಿಮ್ಮ ಹೆಸರು ನಿಮ್ಮ ಪ್ರಶ್ನೆಗೆ ವೈಯಕ್ತಿಕ ಸಂದರ್ಭವನ್ನು ಒದಗಿಸಲು ಸಹಾಯ ಮಾಡುತ್ತದೆ",
    "email_address": "ಇಮೇಲ್ ವಿಳಾಸ",
    "enter_email_address": "ನಿಮ್ಮ ಇಮೇಲ್ ವಿಳಾಸವನ್ನು ನಮೂದಿಸಿ",
    "phone_number": "ದೂರವಾಣಿ ಸಂಖ್ಯೆ",
    "enter_phone_number": "ನಿಮ್ಮ ದೂರವಾಣಿ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ",
    "gender": "ಲಿಂಗ",
    "male": "ಪುರುಷ",
    "female": "ಮಹಿಳೆ",
    "other": "ಇತರೆ",
    "date_of_birth": "ಜನ್ಮ ದಿನಾಂಕ",
    "birth_date_question_context": "ಜ್ಯೋತಿಷ್ಯ ಸಂದರ್ಭ ಮತ್ತು ನಿಖರವಾದ ಉತ್ತರಕ್ಕೆ ಅಗತ್ಯವಾದುದು",
    "your_question": "ನಿಮ್ಮ ಪ್ರಶ್ನೆ",
    "enter_your_question": "ನಿಮ್ಮ ನಿರ್ದಿಷ್ಟ ಪ್ರಶ್ನೆಯನ್ನು ಇಲ್ಲಿ ನಮೂದಿಸಿ...",
    "question_guidance": "ನಿರ್ದಿಷ್ಟ ಮತ್ತು ಸ್ಪಷ್ಟವಾಗಿರಿ. ವೃತ್ತಿ, ಪ್ರೀತಿ, ಹಣಕಾಸು, ಆರೋಗ್ಯ, ಕುಟುಂಬ ಅಥವಾ ಯಾವುದೇ ಜೀವನ ವಿಷಯದ ಬಗ್ಗೆ ಕೇಳಿ",
    "question_category": "ಪ್ರಶ್ನೆ ವರ್ಗ",
    "select_category": "ಪ್ರಶ್ನೆ ವರ್ಗವನ್ನು ಆಯ್ಕೆಮಾಡಿ",
    "career_question": "ವೃತ್ತಿ ಮತ್ತು ವ್ಯಾಪಾರ",
    "love_relationship_question": "ಪ್ರೀತಿ ಮತ್ತು ಸಂಬಂಧಗಳು",
    "finance_question": "ಹಣಕಾಸು ಮತ್ತು ಹಣ",
    "health_question": "ಆರೋಗ್ಯ ಮತ್ತು ಯೋಗಕ್ಷೇಮ",
    "family_question": "ಕುಟುಂಬ ಮತ್ತು ವೈಯಕ್ತಿಕ",
    "spiritual_question": "ಆಧ್ಯಾತ್ಮಿಕ ಮತ್ತು ಬೆಳವಣಿಗೆ",
    "general_question": "ಸಾಮಾನ್ಯ ಜೀವನ",
    "category_helps_accuracy": "ವರ್ಗ ಆಯ್ಕೆಯು ಹೆಚ್ಚು ನಿಖರವಾದ ಮತ್ತು ಸಂಬಂಧಿತ ಉತ್ತರಗಳನ್ನು ಒದಗಿಸಲು ಸಹಾಯ ಮಾಡುತ್ತದೆ",
    "preferred_language": "ಆದ್ಯತೆಯ ಭಾಷೆ",
    "english": "ಇಂಗ್ಲಿಷ್",
    "hindi": "ಹಿಂದಿ",
    "telugu": "ತೆಲುಗು",
    "kannada": "ಕನ್ನಡ",
    "language_note": "ನಿಮ್ಮ ಉತ್ತರವನ್ನು ಆಯ್ಕೆಮಾಡಿದ ಭಾಷೆಯಲ್ಲಿ ತಲುಪಿಸಲಾಗುವುದು",

    // Core Question Features
    "detailed_answer_explanation": "ವಿಸ್ತೃತ ಉತ್ತರ ಮತ್ತು ವಿವರಣೆ",
    "astrological_context": "ಜ್ಯೋತಿಷ್ಯ ಸಂದರ್ಭ",
    "timing_guidance": "ಸಮಯ ಮಾರ್ಗದರ್ಶನ",
    "remedial_suggestions": "ಪರಿಹಾರ ಸಲಹೆಗಳು",
    "follow_up_guidance": "ಫಾಲೋ-ಅಪ್ ಮಾರ್ಗದರ್ಶನ",
    "pdf_answer_report": "PDF ಉತ್ತರ ವರದಿ",

    "what_you_get": "ನಿಮ್ಮ ಉತ್ತರ ಏನನ್ನು ಒಳಗೊಂಡಿದೆ",
    "comprehensive_answer": "ಸಮಗ್ರ ಉತ್ತರ",
    "astrological_insights": "ಜ್ಯೋತಿಷ್ಯ ಒಳನೋಟಗಳು",
    "practical_guidance": "ಪ್ರಾಯೋಗಿಕ ಮಾರ್ಗದರ್ಶನ",
    "remedial_solutions": "ಪರಿಹಾರ ಪರಿಹಾರಗಳು",

    // Actions & Buttons
    "pay_and_get_answer": "ನನ್ನ ಉತ್ತರವನ್ನು ಪಡೆಯಿರಿ",
    "processing_payment": "ಪಾವತಿಯನ್ನು ಪ್ರಕ್ರಿಯೆಗೊಳಿಸಲಾಗುತ್ತಿದೆ",
    "processing_request": "ಪ್ರಶ್ನೆಯನ್ನು ಪ್ರಕ್ರಿಯೆಗೊಳಿಸಲಾಗುತ್ತಿದೆ",

    // Payment & Success Messages
    "thank_you": "ಧನ್ಯವಾದಗಳು",
    "payment_successful": "ಪಾವತಿ ಯಶಸ್ವಿಯಾಗಿದೆ!",
    "question_answer_processing": "ನಿಮ್ಮ ಪ್ರಶ್ನೆಯನ್ನು ನಮ್ಮ ತಜ್ಞ ಜ್ಯೋತಿಷಿಗಳು ವಿಶ್ಲೇಷಿಸುತ್ತಿದ್ದಾರೆ. ನೀವು ಜ್ಯೋತಿಷ್ಯ ಒಳನೋಟಗಳು ಮತ್ತು ಪ್ರಾಯೋಗಿಕ ಮಾರ್ಗದರ್ಶನದೊಂದಿಗೆ ವಿಸ್ತೃತ ವೈಯಕ್ತಿಕ ಉತ್ತರವನ್ನು ಸ್ವೀಕರಿಸುವಿರಿ.",
    "order_id": "ಆರ್ಡರ್ ID",
    "payment_id": "ಪಾವತಿ ID",
    "amount_paid": "ಪಾವತಿಸಿದ ಮೊತ್ತ",

    // Delivery Information
    "delivery_information": "ವಿತರಣಾ ಮಾಹಿತಿ",
    "delivery_time": "ಉತ್ತರ ವಿತರಣೆ",
    "within_6_hours_delivery_note": "ನಿಮ್ಮ ವಿಸ್ತೃತ ಉತ್ತರ 6 ಗಂಟೆಗಳೊಳಗೆ ಸಿದ್ಧವಾಗುತ್ತದೆ",
    "whatsapp_notification": "WhatsApp ಅಪ್‌ಡೇಟ್‌ಗಳು",
    "whatsapp_delivery_note": "WhatsApp ನಲ್ಲಿ ತತ್ಕ್ಷಣ ಸೂಚನೆಗಳನ್ನು ಸ್ವೀಕರಿಸಿ",
    "email_delivery": "ಇಮೇಲ್ ವಿತರಣೆ",
    "email_delivery_note": "ಸಂಪೂರ್ಣ ಉತ್ತರವನ್ನು ತಲುಪಿಸಲಾಗಿದೆ",

    // What You'll Receive
    "what_youll_receive": "ನಿಮ್ಮ ಉತ್ತರ ಪ್ಯಾಕೇಜ್",
    "detailed_answer_report_pdf": "ವಿಸ್ತೃತ ಉತ್ತರ ವರದಿ (PDF)",
    "astrological_explanation": "ಜ್ಯೋತಿಷ್ಯ ವಿವರಣೆ",
    "timing_recommendations": "ಸಮಯ ಶಿಫಾರಸುಗಳು",
    "remedial_measures": "ಪರಿಹಾರ ಕ್ರಮಗಳು",
    "action_plan_guidance": "ಕಾರ್ಯ ಯೋಜನೆ ಮಾರ್ಗದರ್ಶನ",

    // Visual Content
    "sample_question_answer": "ಮಾದರಿ ಪ್ರಶ್ನೆ ಉತ್ತರ",
    "expert_answer": "ತಜ್ಞ ಉತ್ತರ",
    "sample_answer_preview": "ಪ್ರಾಯೋಗಿಕ ಮಾರ್ಗದರ್ಶನ ಮತ್ತು ಸಮಯದೊಂದಿಗೆ ವಿಸ್ತೃತ ಜ್ಯೋತಿಷ್ಯ ಒಳನೋಟಗಳು",
    "sample_question_preview": "ನಮ್ಮ ತಜ್ಞರು ನಿಮ್ಮ ನಿರ್ದಿಷ್ಟ ಪ್ರಶ್ನೆಗಳಿಗೆ ಹೇಗೆ ಉತ್ತರಿಸುತ್ತಾರೆ ಎಂಬುದರ ಪೂರ್ವವೀಕ್ಷಣೆ",
    "question_categories": "ಪ್ರಶ್ನೆ ವರ್ಗಗಳು",

    // Question Category Types
    "career": "ವೃತ್ತಿ",
    "love": "ಪ್ರೀತಿ",
    "finance": "ಹಣಕಾಸು",
    "health": "ಆರೋಗ್ಯ",
    "family": "ಕುಟುಂಬ",
    "spiritual": "ಆಧ್ಯಾತ್ಮಿಕ",

    // Status & Processing
    "your_question_status": "ನಿಮ್ಮ ಪ್ರಶ್ನೆಯ ಸ್ಥಿತಿ",
    "processing_your_question": "ನಿಮ್ಮ ಪ್ರಶ್ನೆಯನ್ನು ವಿಶ್ಲೇಷಿಸಲಾಗುತ್ತಿದೆ",
    "question_processing_message": "ನಮ್ಮ ತಜ್ಞ ಜ್ಯೋತಿಷಿಗಳು ಅತ್ಯಂತ ನಿಖರವಾದ ಮತ್ತು ಸಹಾಯಕಾರಿ ಉತ್ತರವನ್ನು ನೀಡಲು ನಿಮ್ಮ ಜನ್ಮ ಚಾರ್ಟ್ ಅನ್ನು ಅಧ್ಯಯನ ಮಾಡುತ್ತಿದ್ದಾರೆ ಮತ್ತು ನಿಮ್ಮ ಪ್ರಶ್ನೆಯನ್ನು ವಿಶ್ಲೇಷಿಸುತ್ತಿದ್ದಾರೆ.",
    "request_id": "ಪ್ರಶ್ನೆ ID",
    "status": "ಸ್ಥಿತಿ",
    "processing": "ಪ್ರಗತಿಯಲ್ಲಿದೆ",
    "pending": "ಸಾಲಿನಲ್ಲಿದೆ",
    "email_notification_sent": "ದೃಢೀಕರಣ ಇಮೇಲ್ ಕಳುಹಿಸಲಾಗಿದೆ",
    "whatsapp_update_coming": "WhatsApp ಅಪ್‌ಡೇಟ್‌ಗಳನ್ನು ಸಕ್ರಿಯಗೊಳಿಸಲಾಗಿದೆ",
    "delivery_within_6_hours": "6 ಗಂಟೆಗಳೊಳಗೆ ಉತ್ತರ ಸಿದ್ಧ",

    // Support & Contact
    "contact_support": "ಪ್ರಶ್ನೆ ಬೆಂಬಲವನ್ನು ಸಂಪರ್ಕಿಸಿ",
    "need_help": "ಮಾರ್ಗದರ್ಶನ ಬೇಕೇ?",
    "contact_us_at": "ನಮ್ಮನ್ನು ಇಲ್ಲಿ ಸಂಪರ್ಕಿಸಿ",

    // Error Messages
    "please_fill_all_required_fields": "ದಯವಿಟ್ಟು ನಿಮ್ಮ ಪ್ರಶ್ನೆ ಸೇರಿದಂತೆ ಎಲ್ಲಾ ಅಗತ್ಯವಾದ ಕ್ಷೇತ್ರಗಳನ್ನು ಪೂರ್ಣಗೊಳಿಸಿ",
    "payment_failed": "ಪಾವತಿ ವಿಫಲವಾಗಿದೆ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
    "processing_failed": "ಪ್ರಶ್ನೆ ಪ್ರಕ್ರಿಯೆ ವಿಫಲವಾಗಿದೆ. ನಮ್ಮ ಬೆಂಬಲ ತಂಡವನ್ನು ಸಂಪರ್ಕಿಸಿ.",

    // Question Types & Examples
    "career_questions_examples": "ವೃತ್ತಿ ಪ್ರಶ್ನೆಗಳ ಉದಾಹರಣೆಗಳು",
    "when_promotion": "ನಾನು ಯಾವಾಗ ಬಡ್ತಿ ಪಡೆಯುತ್ತೇನೆ?",
    "job_change_timing": "ನಾನು ಈಗ ನನ್ನ ಕೆಲಸವನ್ನು ಬದಲಾಯಿಸಬೇಕೇ?",
    "business_success": "ನನ್ನ ವ್ಯಾಪಾರ ಯಶಸ್ವಿಯಾಗುತ್ತದೆಯೇ?",
    "career_path": "ನನಗೆ ಯಾವ ವೃತ್ತಿ ಮಾರ್ಗ ಅತ್ಯುತ್ತಮವಾಗಿದೆ?",

    "love_questions_examples": "ಪ್ರೀತಿ ಪ್ರಶ್ನೆಗಳ ಉದಾಹರಣೆಗಳು",
    "marriage_timing": "ನಾನು ಯಾವಾಗ ಮದುವೆಯಾಗುತ್ತೇನೆ?",
    "relationship_future": "ನನ್ನ ಸಂಬಂಧದ ಭವಿಷ್ಯ ಏನು?",
    "soulmate_meeting": "ನಾನು ನನ್ನ ಆತ್ಮ ಸಂಗಾತಿಯನ್ನು ಯಾವಾಗ ಭೇಟಿಯಾಗುತ್ತೇನೆ?",
    "love_compatibility_question": "ನಾವು ಮದುವೆಗೆ ಹೊಂದಿಕೊಳ್ಳುತ್ತೇವೆಯೇ?",

    "finance_questions_examples": "ಹಣಕಾಸು ಪ್ರಶ್ನೆಗಳ ಉದಾಹರಣೆಗಳು",
    "money_problems": "ನನ್ನ ಹಣಕಾಸಿನ ಸಮಸ್ಯೆಗಳು ಯಾವಾಗ ಮುಗಿಯುತ್ತವೆ?",
    "investment_timing": "ಹೂಡಿಕೆ ಮಾಡಲು ಇದು ಒಳ್ಳೆಯ ಸಮಯವೇ?",
    "property_purchase": "ನಾನು ಈಗ ಆಸ್ತಿ ಖರೀದಿಸಬೇಕೇ?",
    "debt_relief": "ನಾನು ಯಾವಾಗ ಸಾಲ-ಮುಕ್ತನಾಗುತ್ತೇನೆ?",

    "health_questions_examples": "ಆರೋಗ್ಯ ಪ್ರಶ್ನೆಗಳ ಉದಾಹರಣೆಗಳು",
    "health_recovery": "ನನ್ನ ಆರೋಗ್ಯ ಯಾವಾಗ ಸುಧಾರಿಸುತ್ತದೆ?",
    "surgery_timing": "ಶಸ್ತ್ರಚಿಕಿತ್ಸೆಗೆ ಇದು ಒಳ್ಳೆಯ ಸಮಯವೇ?",
    "chronic_illness": "ನನ್ನ ದೀರ್ಘಕಾಲದ ಕಾಯಿಲೆ ಗುಣವಾಗುತ್ತದೆಯೇ?",
    "fitness_goals": "ನನ್ನ ಆರೋಗ್ಯ ಗುರಿಗಳನ್ನು ನಾನು ಹೇಗೆ ಸಾಧಿಸಬಹುದು?",

    // Answer Components
    "question_analysis": "ಪ್ರಶ್ನೆ ವಿಶ್ಲೇಷಣೆ",
    "birth_chart_insights": "ಜನ್ಮ ಚಾರ್ಟ್ ಒಳನೋಟಗಳು",
    "planetary_influences": "ಗ್ರಹಗಳ ಪ್ರಭಾವಗಳು",
    "current_transits": "ಪ್ರಸ್ತುತ ಸಂಕ್ರಮಣ ಪರಿಣಾಮಗಳು",
    "dasha_analysis": "ದಶಾ ಅವಧಿ ವಿಶ್ಲೇಷಣೆ",
    "yogas_doshas": "ಸಂಬಂಧಿತ ಯೋಗಗಳು ಮತ್ತು ದೋಷಗಳು",

    // Timing Analysis
    "favorable_periods": "ಅನುಕೂಲಕರ ಅವಧಿಗಳು",
    "challenging_periods": "ಸವಾಲಿನ ಅವಧಿಗಳು",
    "optimal_timing": "ಸೂಕ್ತ ಸಮಯ",
    "avoid_periods": "ತಪ್ಪಿಸಬೇಕಾದ ಅವಧಿಗಳು",
    "gradual_improvement": "ಕ್ರಮೇಣ ಸುಧಾರಣೆಯ ಟೈಮ್‌ಲೈನ್",
    "sudden_changes": "ಹಠಾತ್ ಬದಲಾವಣೆ ಸಾಧ್ಯತೆಗಳು",

    // Remedial Solutions
    "gemstone_remedies": "ರತ್ನ ಪರಿಹಾರಗಳು",
    "mantra_recommendations": "ಮಂತ್ರ ಶಿಫಾರಸುಗಳು",
    "charity_suggestions": "ದತ್ತಿ ಚಟುವಟಿಕೆಗಳು",
    "ritual_guidance": "ಆಚರಣೆ ಮತ್ತು ಪೂಜೆ ಮಾರ್ಗದರ್ಶನ",
    "lifestyle_changes": "ಜೀವನಶೈಲಿ ಮಾರ್ಪಾಡುಗಳು",
    "behavioral_adjustments": "ನಡವಳಿಕೆಯ ಹೊಂದಾಣಿಕೆಗಳು",

    // Practical Guidance
    "action_steps": "ಶಿಫಾರಸು ಮಾಡಿದ ಕಾರ್ಯ ಹಂತಗಳು",
    "do_and_dont": "ಮಾಡಬೇಕಾದುದು ಮತ್ತು ಮಾಡಬಾರದುದು",
    "precautions": "ತೆಗೆದುಕೊಳ್ಳಬೇಕಾದ ಮುನ್ನೆಚ್ಚರಿಕೆಗಳು",
    "opportunities": "ಗಮನಿಸಬೇಕಾದ ಅವಕಾಶಗಳು",
    "preparation_tips": "ತಯಾರಿ ಸಲಹೆಗಳು",
    "patience_guidance": "ಯಾವಾಗ ತಾಳ್ಮೆ ಹಿಡಿಯಬೇಕು",

    // Follow-up Information
    "progress_tracking": "ಪ್ರಗತಿ ಟ್ರ್ಯಾಕಿಂಗ್",
    "reassessment_timing": "ಮರು ಮೌಲ್ಯಮಾಪನ ಮಾಡುವ ಸಮಯ",
    "additional_questions": "ಪರಿಗಣಿಸಬೇಕಾದ ಸಂಬಂಧಿತ ಪ್ರಶ್ನೆಗಳು",
    "ongoing_guidance": "ನಿರಂತರ ಮಾರ್ಗದರ್ಶನ",
    "support_resources": "ಬೆಂಬಲ ಸಂಪನ್ಮೂಲಗಳು",
    "expert_consultation": "ತಜ್ಞ ಸಮಾಲೋಚನೆ ಲಭ್ಯ",

    // Question Quality Guidelines
    "specific_questions": "ನಿರ್ದಿಷ್ಟ ಪ್ರಶ್ನೆಗಳನ್ನು ಕೇಳಿ",
    "avoid_yes_no": "ಸರಳ ಹೌದು/ಇಲ್ಲ ಪ್ರಶ್ನೆಗಳನ್ನು ತಪ್ಪಿಸಿ",
    "include_context": "ಸಂಬಂಧಿತ ಸಂದರ್ಭವನ್ನು ಸೇರಿಸಿ",
    "one_main_question": "ಒಂದು ಮುಖ್ಯ ಪ್ರಶ್ನೆಯ ಮೇಲೆ ಗಮನ ಹರಿಸಿ",
    "clear_timeline": "ಬಯಸಿದ ಟೈಮ್‌ಲೈನ್ ಅನ್ನು ಉಲ್ಲೇಖಿಸಿ",
    "personal_concerns": "ವೈಯಕ್ತಿಕ ಕಾಳಜಿಗಳನ್ನು ವ್ಯಕ್ತಪಡಿಸಿ",

    // Answer Accuracy Factors
    "birth_time_accuracy": "ಜನ್ಮ ಸಮಯದ ನಿಖರತೆ ಮುಖ್ಯ",
    "current_circumstances": "ಪ್ರಸ್ತುತ ಜೀವನ ಸಂದರ್ಭಗಳು",
    "personal_efforts": "ವೈಯಕ್ತಿಕ ಪ್ರಯತ್ನಗಳು ಮುಖ್ಯ",
    "free_will_factor": "ಸ್ವತಂತ್ರ ಇಚ್ಛೆಯ ಪರಿಗಣನೆಗಳು",
    "karmic_influences": "ಕಾರ್ಮಿಕ ಪ್ರಭಾವಗಳು",
    "divine_grace": "ದೈವಿಕ ಕೃಪೆಯ ಅಂಶ",

    // Special Question Categories
    "urgent_questions": "ತುರ್ತು ಜೀವನ ಪ್ರಶ್ನೆಗಳು",
    "long_term_planning": "ದೀರ್ಘಾವಧಿ ಜೀವನ ಯೋಜನೆ",
    "decision_making": "ಪ್ರಮುಖ ನಿರ್ಧಾರ ತೆಗೆದುಕೊಳ್ಳುವಿಕೆ",
    "crisis_management": "ಬಿಕ್ಕಟ್ಟು ಮತ್ತು ಸವಾಲು ನಿರ್ವಹಣೆ",
    "opportunity_evaluation": "ಅವಕಾಶ ಮೌಲ್ಯಮಾಪನ",
    "relationship_counseling": "ಸಂಬಂಧ ಮಾರ್ಗದರ್ಶನ",

    // Confidentiality
    "privacy_assurance": "ಸಂಪೂರ್ಣ ಗೌಪ್ಯತೆ ಖಾತ್ರಿ",
    "confidential_handling": "ಗೌಪ್ಯ ಪ್ರಶ್ನೆ ನಿರ್ವಹಣೆ",
    "secure_communication": "ಸುರಕ್ಷಿತ ಸಂವಹನ",
    "expert_discretion": "ತಜ್ಞ ವಿವೇಚನೆ ನಿರ್ವಹಣೆ",
    "no_judgment": "ನಿರ್ಣಯರಹಿತ ವಿಧಾನ",
    "supportive_guidance": "ಬೆಂಬಲ ಮತ್ತು ಸಹಾನುಭೂತಿಯ ಮಾರ್ಗದರ್ಶನ"
};

export default askquestion;
